import { useState, useEffect } from "react";
import ElementoParcela from "./ElementoParcela";
import moment from "moment/moment";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { v4 as uuidv4 } from "uuid";
import "./ModalAprovarOrcamento.scss";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import InputText from "../../../../../../shared/components/inputs/InputText/InputText";
import toast from "react-hot-toast";
import { useLoading } from "../../../../../../shared/context/LoadingContext";

import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import { X, Plus } from "lucide-react";

import { updateCalculations } from "./discountCalculations";

import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import Typography from "@mui/material/Typography";

import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import NotaInformativa from "../../../../../../shared/components/notaInformativa/NotaInformativa";

function ModalAprovarOrcamento({
  open,
  modalData,
  handleCloseModalAprovarOrcamento,
  sendRequest,
  auth,
  contaCorrente,
  updateOrcamentos,
  clinica,
}) {
  const [subtotal, setSubtotal] = useState(0);
  const [subtotalCliente, setSubtotalCliente] = useState(
    modalData.orcamento.subtotalCliente,
  );
  const [total, setTotal] = useState(0);
  const [caixaClinicaId, setCaixaClinicaId] = useState();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [nrParcelas, setNrParcelas] = useState(modalData.conta.nrParcelas);
  const [totalParcelas, setTotalParcelas] = useState(() => {
    return modalData.conta.parcelas.reduce(
      (sum, parcela) => sum + parcela.quantiaPorPagar,
      0,
    );
  });
  const [categoriaBeneficiario, setCategoriaBeneficiario] = useState(
    modalData.orcamento.categoriaBeneficiario || "",
  );

  const [mensagemErro, setMensagemErro] = useState("");
  const [parcelas, setParcelas] = useState(modalData.conta.parcelas);
  const [showParcelarOrcamento, setShowParcelarOrcamento] = useState(
    modalData.conta.nrParcelas > 1,
  );

  const [majoracao, setMajoracao] = useState(
    modalData.orcamento.majoracao || 0,
  );
  const [majoracaoAutomatica, setMajoracaoAutomatica] = useState(false);

  // Adaptação para o novo sistema
  const [tipoCobertura, setTipoCobertura] = useState(
    modalData.orcamento.tipoCobertura,
  );

  const instituicao = modalData.orcamento.instituicaoCobertura;

  const modalidadePagamento = modalData.orcamento.modalidadePagamento;

  const [serviceList, setServiceList] = useState(() =>
    modalData.orcamento.procedimentos.map((p) => {
      // Buscar informações de cobertura da instituição se aplicável
      let cobertura = null;
      if (instituicao && p.tratamento.precosPorInstituicao) {
        cobertura = p.tratamento.precosPorInstituicao.find(
          (pi) =>
            pi.instituicao === instituicao._id ||
            pi.instituicao._id === instituicao._id,
        );
      }

      return {
        ...p,
        show: true,
        cobertura: cobertura,
        preco_total: p.valor_cliente,
        valor_cliente: p.valor_cliente,
      };
    }),
  );

  const [dataCredencial, setDataCredencial] = useState(
    modalData.orcamento.dataCredencial
      ? moment(modalData.orcamento.dataCredencial)
      : null,
  );

  const [nrCredencial, setNrCredencial] = useState(
    modalData.orcamento.nrCredencial || "000000000",
  );

  const [confirmDialog, setConfirmDialog] = useState({
    open: false,
    agendamentos: [],
    mensagem: "",
    confirmarConversao: false,
    agendamentosParaRemover: null,
    parcelasFinal: null,
  });

  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    if (
      majoracaoAutomatica &&
      tipoCobertura !== "PARTICULAR" &&
      modalidadePagamento !== "REEMBOLSO_CLIENTE"
    ) {
      const totalCobertura = serviceList
        .filter((s) => s.show)
        .reduce((acc, service) => acc + (service.valor_cobertura || 0), 0);

      let valorMajoracao = Math.ceil((totalCobertura * 15) / 100);

      // Verificar se o total ficaria negativo
      if (
        valorMajoracao > 0 &&
        updateCalculations(
          serviceList,
          modalData.orcamento.desconto,
          modalData.orcamento.tipoDesconto,
          modalData.orcamento.percentagemDescontoOriginal,
          valorMajoracao,
          modalidadePagamento,
          tipoCobertura,
        ).newTotal < 0
      ) {
        valorMajoracao =
          valorMajoracao -
          Math.abs(
            updateCalculations(
              serviceList,
              modalData.orcamento.desconto,
              modalData.orcamento.tipoDesconto,
              modalData.orcamento.percentagemDescontoOriginal,
              valorMajoracao,
              modalidadePagamento,
              tipoCobertura,
            ).newTotal,
          );
      }

      let { newTotal } = updateCalculations(
        serviceList,
        modalData.orcamento.desconto,
        modalData.orcamento.tipoDesconto,
        modalData.orcamento.percentagemDescontoOriginal,
        valorMajoracao,
        modalidadePagamento,
        tipoCobertura,
      );

      setMajoracao(valorMajoracao);
      setTotal(newTotal);
      setTotalParcelas(newTotal);
      resetParcelas();
    }
  }, [majoracaoAutomatica, serviceList, tipoCobertura, modalidadePagamento]);

  useEffect(() => {
    const fetchCaixas = async () => {
      startLoading();
      try {
        // Buscar caixas
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${contaCorrente.clinica}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setCaixaClinicaId(
          responseData.caixas.find((cai) => cai.caixa === "Clínica")._id,
        );
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };
    fetchCaixas();
  }, []);

  useEffect(() => {
    const { newSubtotal, newTotal, newSubtotalCliente } = updateCalculations(
      serviceList,
      modalData.orcamento.desconto,
      modalData.orcamento.tipoDesconto,
      modalData.orcamento.percentagemDescontoOriginal,
      majoracao,
      modalidadePagamento,
      tipoCobertura,
    );
    setSubtotalCliente(newSubtotalCliente);
    setSubtotal(newSubtotal);
    setTotal(newTotal);

    const updatedTotalParcelas = parcelas.reduce(
      (sum, parcela) => sum + parcela.quantiaPorPagar,
      0,
    );
    setTotalParcelas(updatedTotalParcelas);
  }, [modalData, serviceList]);

  useEffect(() => {
    resetParcelas();
  }, [total, showParcelarOrcamento]);

  const resetParcelas = () => {
    let newParcelas = [];
    const installmentValue = Math.floor(total / parcelas.length);

    for (let i = 0; i < parcelas.length; i++) {
      if (i === parcelas.length - 1) {
        newParcelas.push({
          ...parcelas[i],
          quantiaPorPagar: total - (parcelas.length - 1) * installmentValue,
          descricao: "",
        });
      } else {
        newParcelas.push({
          ...parcelas[i],
          quantiaPorPagar: installmentValue,
          descricao: "",
        });
      }
    }
    setParcelas(newParcelas);
  };

  const createParcela = (valor, diasAdicionar, descricao) => ({
    id: uuidv4(),
    dataLimitePagamento: moment().add(diasAdicionar, "days"),
    parcelaPaga: false,
    quantiaPaga: 0,
    quantiaPorPagar: valor,
    descricao: descricao || "",
  });

  const nrParcelasChange = (e) => {
    setMensagemErro("");
    const novoNrParcelas = Math.max(1, Number(e.target.value) || 1);
    let newParcelas = [];

    const valorPorParcela = Math.floor(total / novoNrParcelas);
    for (let i = 0; i < novoNrParcelas; i++) {
      newParcelas.push(
        createParcela(
          i === novoNrParcelas - 1
            ? total - (novoNrParcelas - 1) * valorPorParcela
            : valorPorParcela,
          (i + 1) *
            clinica.clinica.configuracoes.configuracoes.validadeParcela
              .validade,
        ),
      );
    }

    setParcelas(newParcelas);
    setNrParcelas(novoNrParcelas);
    setTotalParcelas(total);
  };

  const dataLimitePagamentoChange = (indice, valor) => {
    const parcelasCopy = [...parcelas];
    parcelasCopy[indice].dataLimitePagamento = valor;
    setParcelas(parcelasCopy);
  };

  const parcelasValueChange = (indice, valor) => {
    const parcelasCopy = [...parcelas];
    parcelasCopy[indice].quantiaPorPagar = Number(valor);

    let totalAteEssaParcela = parcelasCopy
      .slice(0, indice + 1)
      .reduce((sum, p) => sum + p.quantiaPorPagar, 0);

    if (totalAteEssaParcela < total) {
      const valorRestante = total - totalAteEssaParcela;
      const nrParcelasRestantes = parcelasCopy.length - (indice + 1);
      const valorPorParcela = Math.floor(valorRestante / nrParcelasRestantes);

      for (let i = indice + 1; i < parcelasCopy.length; i++) {
        parcelasCopy[i].quantiaPorPagar =
          i === parcelasCopy.length - 1
            ? valorRestante - (nrParcelasRestantes - 1) * valorPorParcela
            : valorPorParcela;
        parcelasCopy[i].descricao = "";
      }
    } else {
      for (let i = indice + 1; i < parcelasCopy.length; i++) {
        parcelasCopy[i].quantiaPorPagar = 0;
        parcelasCopy[i].descricao = "";
      }
    }

    setParcelas(parcelasCopy);
    setTotalParcelas(
      parcelasCopy.reduce((sum, p) => sum + p.quantiaPorPagar, 0),
    );
  };

  const showParcelarOrcamentoHandler = (e) => {
    const isChecked = e.target.checked;
    setShowParcelarOrcamento(isChecked);

    let newParcelas = [];
    if (isChecked) {
      const installmentValue = Math.floor(total / 2);
      newParcelas.push(
        createParcela(
          installmentValue,
          clinica.clinica.configuracoes.configuracoes.validadeParcela.validade,
          false,
        ),
      );
      newParcelas.push(createParcela(total - installmentValue, 30, false));
      setNrParcelas(2);
    } else {
      newParcelas.push(createParcela(total, 0, false));
      setNrParcelas(1);
    }

    setParcelas(newParcelas);
    setTotalParcelas(total);
  };

  const handleRemoveTratamento = (index) => {
    const updatedServiceList = serviceList.map((service, i) =>
      i === index ? { ...service, show: false } : service,
    );

    const visibleServicesAfterRemoval = updatedServiceList.filter(
      (service) => service.show,
    );

    if (visibleServicesAfterRemoval.length === 0) {
      setServiceList(updatedServiceList);
      updateParcelasAfterServiceChange(updatedServiceList);
      return;
    }

    // Verificar se ainda há tratamentos cobertos após a remoção
    const stillHasCoveredTreatments = visibleServicesAfterRemoval.some(
      (service) => service.cobertura?.coberto,
    );

    // Atualizar tipo de cobertura se necessário
    if (tipoCobertura !== "PARTICULAR" && !stillHasCoveredTreatments) {
      toast.error(
        `Não restam mais tratamentos cobertos pela ${
          instituicao?.nome || "instituição"
        }. O orçamento será transformado em Particular.`,
      );
      setTipoCobertura("PARTICULAR");
      setMajoracao(0);
    }

    // Recalcular majoração automática se ativada
    let novoValorMajoracao = majoracao;
    if (
      majoracaoAutomatica &&
      tipoCobertura !== "PARTICULAR" &&
      modalidadePagamento !== "REEMBOLSO_CLIENTE"
    ) {
      const totalCobertura = visibleServicesAfterRemoval.reduce(
        (acc, service) => acc + (service.valor_cobertura || 0),
        0,
      );
      novoValorMajoracao = Math.ceil((totalCobertura * 15) / 100);
      setMajoracao(novoValorMajoracao);
    }

    setServiceList(updatedServiceList);
    updateParcelasAfterServiceChange(updatedServiceList, novoValorMajoracao);
  };

  const handleAddTratamento = (index) => {
    const updatedServiceList = serviceList.map((service, i) =>
      i === index ? { ...service, show: true } : service,
    );

    // Verificar se há tratamentos cobertos
    const hasCoveredTreatments = updatedServiceList.some(
      (service) => service.show && service.cobertura?.coberto,
    );

    // Se voltou a ter tratamentos cobertos e estava como PARTICULAR
    if (tipoCobertura === "PARTICULAR" && hasCoveredTreatments && instituicao) {
      toast.success(
        `Você adicionou um tratamento com cobertura ${instituicao.nome}. O orçamento voltará a ter cobertura.`,
      );
      setTipoCobertura(modalData.orcamento.tipoCobertura);
    }

    // Recalcular majoração automática se ativada
    let novoValorMajoracao = majoracao;
    if (
      majoracaoAutomatica &&
      tipoCobertura !== "PARTICULAR" &&
      modalidadePagamento !== "REEMBOLSO_CLIENTE"
    ) {
      const visibleServices = updatedServiceList.filter(
        (service) => service.show,
      );
      const totalCobertura = visibleServices.reduce(
        (acc, service) => acc + (service.valor_cobertura || 0),
        0,
      );
      novoValorMajoracao = Math.ceil((totalCobertura * 15) / 100);
      setMajoracao(novoValorMajoracao);
    }

    setServiceList(updatedServiceList);
    updateParcelasAfterServiceChange(updatedServiceList, novoValorMajoracao);
  };

  const preSubmit = () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    if (serviceList.filter((s) => s.show).length <= 0) {
      setMensagemErro(
        "Nenhum tratamento selecionado. Selecione pelo menos 1 tratamento para prosseguir!",
      );
      setIsSubmitting(false);
      return;
    }

    const parcelasFinal = [...parcelas];

    if (total < 0) {
      setMensagemErro("O total não pode ser um valor negativo!");
      setIsSubmitting(false);
      return;
    }

    if (totalParcelas !== total) {
      setMensagemErro(
        `A soma dos valores (${totalParcelas}$00) é ${
          totalParcelas < total ? "inferior" : "superior"
        } ao valor total do orçamento (${total}$00).`,
      );
      setIsSubmitting(false);
      return;
    }

    const negativeParcela = parcelasFinal.find((p) => p.quantiaPorPagar < 0);
    if (negativeParcela) {
      setMensagemErro("Não é permitido ter parcelas com valores negativos.");
      setIsSubmitting(false);
      return;
    }

    if (parcelasFinal.some((p) => p.quantiaPorPagar === 0)) {
      if (total === 0 && modalData.orcamento.desconto <= 0) {
        setMensagemErro(
          "Não é permitida isenção sem desconto. Ajuste a majoração para manter um valor a pagar.",
        );
        setIsSubmitting(false);
        return;
      } else if (total > 0) {
        setMensagemErro("Preencha todas as parcelas com valor superior a 0.");
        setIsSubmitting(false);
        return;
      }
    }

    const parcelasSemData = parcelasFinal.filter((p) => !p.dataLimitePagamento);
    const parcelasComErroEmData = parcelasFinal.filter(
      (p) =>
        !moment.isMoment(p.dataLimitePagamento) ||
        !p.dataLimitePagamento?.isValid(),
    );

    // Validação para credenciais (quando tem instituição com envio)
    if (
      instituicao &&
      modalData.orcamento.envioInstituicao?.enviado !== true &&
      modalidadePagamento !== "REEMBOLSO_CLIENTE"
    ) {
      if (!dataCredencial) {
        setMensagemErro("A data de credencial é obrigatória");
        setIsSubmitting(false);
        return;
      } else if (
        !moment.isMoment(dataCredencial) ||
        !dataCredencial?.isValid()
      ) {
        setMensagemErro("Preencha a data de credencial corretamente.");
        setIsSubmitting(false);
        return;
      }

      if (!nrCredencial || nrCredencial.trim() === "") {
        setMensagemErro(
          `O número de credencial é obrigatório para orçamentos ${instituicao.nome}`,
        );
        setIsSubmitting(false);
        return;
      }
    }

    if (parcelasSemData.length > 0) {
      setMensagemErro("Preencha as datas de vencimento em todas as parcelas");
      setIsSubmitting(false);
      return;
    }

    if (parcelasComErroEmData.length > 0) {
      setMensagemErro(
        "As datas de vencimento não estão preenchidas corretamente",
      );
      setIsSubmitting(false);
      return;
    }

    const parcelasLength = parcelasFinal.length;
    parcelasFinal.forEach((parcela, index) => {
      parcela.nrParcela = `${index + 1}/${parcelasLength}`;
      delete parcela.id;
    });

    submit(parcelasFinal);
  };

  const submit = async (parcelasFinal, forcarConfirmacao = false) => {
    startLoading();

    try {
      const shownServices = serviceList.filter((s) => s.show === true);
      const hiddenServices = serviceList.filter((s) => s.show === false);

      if (shownServices.length === 0) {
        toast.error("Nenhum procedimento selecionado!");
        stopLoading();
        return;
      }

      // Preparar procedimentos para o plano de tratamento
      const procedimentosPlanoTratamento = shownServices.map((pr) => ({
        tratamento: pr.tratamento._id,
        dente: pr.dente,
        faces: pr.faces,
        procedimento_completo: false,
      }));

      // Calcular valor total de cobertura
      const valorCobertura = shownServices.reduce((acc, service) => {
        return acc + (service.valor_cobertura || 0);
      }, 0);

      // Preparar dados para envio
      const requestData = {
        // Dados do Plano de Tratamento
        procedimentosPlanoTratamento,

        // Dados do Orçamento
        procedimentosOrcamento: shownServices.map((s) => ({
          ...s,
          tratamento: s.tratamento._id,
          cobertura: undefined, // Remove campo não necessário
        })),

        // Dados de cobertura
        tipoCobertura,
        instituicaoCobertura: instituicao?._id || null,
        modalidadePagamento: instituicao ? modalidadePagamento : null,
        valorCobertura,

        // Dados financeiros
        parcelas: parcelasFinal,
        total,
        subtotal,
        subtotalCliente,
        desconto:
          modalData.orcamento.tipoDesconto === "%"
            ? subtotal - total
            : modalData.orcamento.desconto,

        // modalData.orcamento.tipoDesconto === "%"
        //   ? Math.round(
        //       (subtotal * modalData.orcamento.percentagemDescontoOriginal) /
        //         100
        //     )
        //   : modalData.orcamento.desconto,

        tipoDesconto: modalData.orcamento.tipoDesconto,
        percentagemDescontoOriginal:
          modalData.orcamento.percentagemDescontoOriginal,

        // Dados gerais
        observacoes: modalData.orcamento.observacoes,
        beneficio:
          tipoCobertura === "PARTICULAR" ? "Particular" : instituicao?.nome,
        majoracao,
        comMajoracao: instituicao && majoracao > 0,

        // Credencial (se tem instituição)
        ...(instituicao && {
          dataCredencial,
          nrCredencial,
        }),

        // IDs necessários
        cliente: modalData.orcamento.cliente._id,
        clinica: modalData.orcamento.clinica._id,
        medicoResponsavel: modalData.orcamento.medico_responsavel._id,
        utilizador: auth.userId,
        caixaClinicaId,
        contaCorrenteId: contaCorrente._id,
        contaId: modalData.conta._id,

        // Aprovação parcial
        aprovacaoParcial:
          modalData.orcamento.procedimentos.length !== shownServices.length,

        // Flag de confirmação de conversão de agendamentos
        confirmarConversaoAgendamentos:
          forcarConfirmacao || confirmDialog.confirmarConversao,

        categoriaBeneficiario: categoriaBeneficiario,
      };

      // Se for aprovação parcial, adicionar dados da avaliação
      if (requestData.aprovacaoParcial) {
        const newProcedimentosAvaliacao =
          modalData.orcamento.avaliacao.procedimentos.map((procedimento) => {
            const isHidden = hiddenServices.some(
              (service) => service.id === procedimento._id,
            );
            return {
              ...procedimento,
              orcamentado: !isHidden,
              tratamento: procedimento.tratamento._id,
            };
          });

        requestData.avaliacaoId = modalData.orcamento.avaliacao._id;
        requestData.procedimentosAvaliacao = newProcedimentosAvaliacao;
      }

      // Chamada única para o backend
      const response = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/orcamentos/aprovar/${modalData.orcamento._id}`,
        "POST",
        JSON.stringify(requestData),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        },
      );

      // ADICIONAR: Verificar se precisa confirmação para conversão de agendamentos
      if (response.necessitaConfirmacao && response.agendamentosProvisarios) {
        stopLoading();
        setIsSubmitting(false);

        // Abrir dialog de confirmação
        setConfirmDialog({
          open: true,
          agendamentos: response.agendamentosProvisarios.agendamentos,
          mensagem: response.mensagem,
          tipo: response.agendamentosProvisarios.tipo,
          quantidade: response.agendamentosProvisarios.quantidade,
          aprovacaoParcial: requestData.aprovacaoParcial,
          agendamentosParaRemover: response.agendamentosParaRemover,
          parcelasFinal: parcelasFinal,
        });

        return;
      }

      // IMPORTANTE: Verificar se a resposta tem o orçamento antes de chamar updateOrcamentos
      if (response.success && response.orcamento) {
        toast.success(
          `Orçamento ${
            total === 0 ? "Isento de Pagamento, " : ""
          }aprovado com sucesso!`,
        );

        // Se converteu agendamentos, mostrar informação adicional
        if (response.agendamentosConvertidos) {
          toast.success(
            `${response.agendamentosConvertidos.quantidade} agendamento(s) convertido(s) para o plano de tratamento`,
          );
        }

        updateOrcamentos(response.orcamento);

        // Resetar estado de confirmação
        setConfirmDialog({
          open: false,
          agendamentos: [],
          mensagem: "",
          confirmarConversao: false,
          agendamentosParaRemover: null,
          parcelasFinal: null,
        });

        handleCloseModalAprovarOrcamento();
      }
    } catch (err) {
      console.error("Erro na aprovação:", err);
      toast.error(err.message || "Erro ao aprovar orçamento");
    } finally {
      stopLoading();
      setIsSubmitting(false);
    }
  };

  // ADICIONAR: Função para confirmar conversão de agendamentos
  const handleConfirmarConversao = () => {
    // Fechar dialog e marcar como confirmado
    setConfirmDialog({
      open: false,
      agendamentos: [],
      mensagem: "",
      confirmarConversao: true, // Manter true para a próxima chamada
      parcelasFinal: confirmDialog.parcelasFinal,
    });

    // Reenviar com confirmação
    submitComConfirmacao(confirmDialog.parcelasFinal);
  };

  const submitComConfirmacao = async (parcelasFinal) => {
    // Chamar submit mas com flag de confirmação já setado
    await submit(parcelasFinal, true);
  };

  const handleCancelarConversao = () => {
    setConfirmDialog({
      open: false,
      agendamentos: [],
      mensagem: "",
      confirmarConversao: false,
      agendamentosParaRemover: null,
      parcelasFinal: null,
    });
    setIsSubmitting(false);
  };

  const nrCredencialChangeHandler = (value) => {
    setNrCredencial(value);
  };

  const majoracaoChangeHandler = (event) => {
    if (majoracaoAutomatica) return;

    const value = parseFloat(event.target.value) || 0;
    let valorMajoracao = value;

    if (
      value > 0 &&
      updateCalculations(
        serviceList,
        modalData.orcamento.desconto,
        modalData.orcamento.tipoDesconto,
        modalData.orcamento.percentagemDescontoOriginal,
        valorMajoracao,
        modalidadePagamento,
        tipoCobertura,
      ).newTotal < 0
    ) {
      valorMajoracao =
        value -
        Math.abs(
          updateCalculations(
            serviceList,
            modalData.orcamento.desconto,
            modalData.orcamento.tipoDesconto,
            modalData.orcamento.percentagemDescontoOriginal,
            valorMajoracao,
            modalidadePagamento,
            tipoCobertura,
          ).newTotal,
        );
    }

    let { newTotal } = updateCalculations(
      serviceList,
      modalData.orcamento.desconto,
      modalData.orcamento.tipoDesconto,
      modalData.orcamento.percentagemDescontoOriginal,
      valorMajoracao,
      modalidadePagamento,
      tipoCobertura,
    );

    setMajoracao(valorMajoracao);
    setTotal(newTotal);
    setTotalParcelas(newTotal);
    resetParcelas();
  };

  const updateParcelasAfterServiceChange = (
    updatedServiceList,
    majoracaoValue = majoracao,
  ) => {
    const { newTotal } = updateCalculations(
      updatedServiceList,
      modalData.orcamento.desconto,
      modalData.orcamento.tipoDesconto,
      modalData.orcamento.percentagemDescontoOriginal,
      majoracaoValue,
      modalidadePagamento,
      tipoCobertura,
    );

    const updatedParcelas = parcelas.map((parcela, index) => {
      const parcelasCount = parcelas.length;
      const newQuantiaPorPagar = Math.floor(newTotal / parcelasCount);

      if (index === parcelas.length - 1) {
        return {
          ...parcela,
          quantiaPorPagar: newTotal - (parcelasCount - 1) * newQuantiaPorPagar,
          descricao: "",
        };
      } else {
        return {
          ...parcela,
          quantiaPorPagar: newQuantiaPorPagar,
          descricao: "",
        };
      }
    });

    setParcelas(updatedParcelas);
    setTotal(newTotal);
    setTotalParcelas(newTotal);
  };

  // Função auxiliar para obter o valor do procedimento
  const getValorProcedimento = (procedimento) => {
    return procedimento.valor_cliente;
  };

  // Função auxiliar para obter o valor de comparticipação
  const getValorComparticipacao = (procedimento) => {
    if (tipoCobertura === "PARTICULAR" || !procedimento.cobertura?.coberto) {
      return null;
    }

    return (
      procedimento.valor_cobertura ||
      procedimento.cobertura?.comparticipacao ||
      0
    );
  };

  const parcelarPorTratamento = () => {
    let newParcelas = [];
    const seenServices = serviceList.filter((s) => s.show);
    const novoNrParcelas = seenServices.length;

    seenServices.forEach((s, index) => {
      newParcelas.push(
        createParcela(
          s.valor_cliente,
          (index + 1) *
            clinica.clinica.configuracoes.configuracoes.validadeParcela
              .validade,
          s.tratamento.designacao,
        ),
      );
    });
    setParcelas(newParcelas);
    setNrParcelas(novoNrParcelas);
  };

  const handleMajoracaoAutomaticaChange = (event) => {
    const isChecked = event.target.checked;
    setMajoracaoAutomatica(isChecked);

    if (!isChecked) {
      // Quando desativa, mantém o valor atual mas permite edição
      setMajoracao(majoracao);
    }
  };

  return (
    <>
      <Modal
        open={open}
        onClose={handleCloseModalAprovarOrcamento}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box aprovar-orcamento__modal"
          id="modal__aprovar-orcamento"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Aprovar Orçamento {modalData.orcamento.codigo} -{" "}
            {tipoCobertura === "PARTICULAR"
              ? "Particular"
              : `${instituicao?.nome || modalData.orcamento.beneficio}${
                  modalidadePagamento
                    ? ` (${
                        modalidadePagamento === "DIRETO"
                          ? "Direto"
                          : "Reembolso"
                      })`
                    : ""
                }`}
          </h1>
          {/* A frase sobre o plano e os débitos já existia aqui, solta. Passou
              para a caixa de informação para ganhar a companhia da nota sobre a
              credencial — que é a dúvida que faz as pessoas fechar a janela sem
              aprovar, à espera de um papel que ainda não têm. */}
          <NotaInformativa
            titulo="O que acontece ao aprovar"
            style={{ margin: "0 0 18px" }}
          >
            <ul style={{ margin: 0, paddingLeft: "18px" }}>
              <li>
                O <strong>plano de tratamento é criado</strong> automaticamente,
                na aba Planos Tratamento.
              </li>
              <li>
                Os valores são <strong>lançados em Débito</strong>, com as
                parcelas indicadas em baixo.
              </li>
              {tipoCobertura !== "PARTICULAR" &&
                instituicao &&
                modalidadePagamento !== "REEMBOLSO_CLIENTE" && (
                  <li>
                    Ainda não tem a credencial? <strong>Aprove na mesma</strong>
                    : deixe a data de hoje e o número como está. Depois corrige
                    os dois no orçamento, pelo menu de três pontos, em{" "}
                    <strong>«Editar Dados Credencial»</strong>.
                  </li>
                )}
            </ul>
          </NotaInformativa>

          <div className="aprovar-orcamento__modal__procedimentos__container">
            <div
              className={`aprovar-orcamento__modal__procedimentos__container__item ${
                tipoCobertura === "PARTICULAR"
                  ? " aprovar-orcamento__modal__procedimentos__container__item--particular"
                  : ""
              }`}
            >
              <span className="aprovar-orcamento__modal__procedimentos__container__item__title">
                Tratamento
              </span>
              <span className="aprovar-orcamento__modal__procedimentos__container__item__title">
                Dentes/Região
              </span>

              {tipoCobertura !== "PARTICULAR" && (
                <span className="aprovar-orcamento__modal__procedimentos__container__item__title">
                  {instituicao?.nome || "Instituição"}
                </span>
              )}
              <span className="aprovar-orcamento__modal__procedimentos__container__item__title">
                Beneficiário
              </span>
              <span className="aprovar-orcamento__modal__procedimentos__container__item__title">
                Ação
              </span>
            </div>
            {serviceList &&
              serviceList.length > 0 &&
              serviceList.map((s, index) => (
                <div
                  className={`aprovar-orcamento__modal__procedimentos__container__item ${
                    tipoCobertura === "PARTICULAR"
                      ? " aprovar-orcamento__modal__procedimentos__container__item--particular"
                      : ""
                  }`}
                  key={index}
                >
                  <span
                    className={
                      s.show === false
                        ? "aprovar-orcamento__modal__procedimentos__container__item__out"
                        : "aprovar-orcamento__modal__tableRow"
                    }
                  >
                    {s.tratamento.designacao}
                  </span>
                  <span
                    className={
                      s.show === false
                        ? "aprovar-orcamento__modal__procedimentos__container__item__out"
                        : "aprovar-orcamento__modal__tableRow"
                    }
                  >
                    {s.dente}
                  </span>

                  {tipoCobertura !== "PARTICULAR" && (
                    <span
                      className={
                        s.show === false
                          ? "aprovar-orcamento__modal__procedimentos__container__item__out"
                          : "aprovar-orcamento__modal__tableRow"
                      }
                    >
                      {getValorComparticipacao(s) || ""}
                    </span>
                  )}

                  <span
                    className={
                      s.show === false
                        ? "aprovar-orcamento__modal__procedimentos__container__item__out"
                        : "aprovar-orcamento__modal__tableRow"
                    }
                  >
                    {getValorProcedimento(s)}
                  </span>

                  {s.show && (
                    <Tooltip title="Remover">
                      <IconButton
                        onClick={() => handleRemoveTratamento(index)}
                        className="modalAprovar__icon"
                      >
                        <X className="modalAprovar__icon--remove" />
                      </IconButton>
                    </Tooltip>
                  )}

                  {!s.show && (
                    <Tooltip title="Adicionar">
                      <IconButton
                        onClick={() => handleAddTratamento(index)}
                        className="modalAprovar__icon"
                      >
                        <Plus className="modalAprovar__icon--add" />
                      </IconButton>
                    </Tooltip>
                  )}
                </div>
              ))}
          </div>

          <div className="aprovar-orcamento__modal__valor-orcamento-container">
            Valor Total do Orçamento:{" "}
            <span className="aprovar-orcamento__modal__valor-orcamento-span">
              {total}$00
            </span>{" "}
            <>
              &rArr; Soma dos valores:{" "}
              <span className="aprovar-orcamento__modal__valor-orcamento-span">
                {totalParcelas}$00
              </span>
            </>
          </div>
          <div className="aprovar-orcamento__modal__valor-orcamento-container">
            Desconto:{" "}
            <span className="aprovar-orcamento__modal__valor-orcamento-span">
              {modalData.orcamento.tipoDesconto === "%"
                ? `${modalData.orcamento.percentagemDescontoOriginal}% => ${(
                    subtotal - total
                  ).toLocaleString("pt-BR")}$00`
                : modalData.orcamento.desconto + "$00"}
            </span>{" "}
          </div>

          <div className="aprovarOrcamento__parcelasCredencial__container">
            <div className="aprovarOrcamento__parcelasCredencial__container__item">
              <div className="aprovar-orcamento__modal__descricao-container">
                <div className="parcelarOrcamentoDiv">
                  <label htmlFor="" className="parcelarOrcamento">
                    <input
                      type="checkbox"
                      className="checkbox"
                      onChange={showParcelarOrcamentoHandler}
                      checked={showParcelarOrcamento}
                    />
                    Parcelar Orcamento
                  </label>
                  {showParcelarOrcamento && (
                    <>
                      <button
                        onClick={parcelarPorTratamento}
                        className={`btn__parcelarPorTratamento blue-button ${
                          majoracao > 0 || modalData.orcamento.desconto > 0
                            ? "btn__parcelarPorTratamento--disabled"
                            : ""
                        }`}
                        disabled={
                          majoracao > 0 || modalData.orcamento.desconto > 0
                        }
                        title={
                          majoracao > 0 || modalData.orcamento.desconto > 0
                            ? "Não é possivel parcelar por valor de tratamento quando existe desconto ou majoração no orçamento!"
                            : ""
                        }
                      >
                        Parcelar por valor de tratamento
                      </button>

                      <div className="parcelarOrcamentoDivHorizontal">
                        Parcelar em
                        <input
                          type="number"
                          className="aprovar-orcamento__modal__nrParcelas"
                          value={nrParcelas}
                          onChange={nrParcelasChange}
                          min={1}
                        />
                        {nrParcelas === 1 ? "vez" : "vezes"}
                      </div>
                    </>
                  )}
                </div>
              </div>
              {parcelas &&
                parcelas.map((parcela, index) => (
                  <ElementoParcela
                    key={index}
                    dataLimitePagamento={parcela.dataLimitePagamento}
                    quantiaPorPagar={parcela.quantiaPorPagar}
                    indiceParcela={index}
                    totalParcelas={nrParcelas}
                    parcelasValueChange={parcelasValueChange}
                    dataLimitePagamentoChange={dataLimitePagamentoChange}
                  />
                ))}
            </div>

            {tipoCobertura !== "PARTICULAR" &&
              instituicao &&
              modalidadePagamento !== "REEMBOLSO_CLIENTE" && (
                <div className="modalCredencialContainer aprovarOrcamento__parcelasCredencial__container__item">
                  <h2>Inserir dados de credencial - {instituicao.nome}</h2>
                  <LocalizationProvider
                    dateAdapter={AdapterMoment}
                    className="adicionar-despesa__modal__container--span1"
                  >
                    <DesktopDatePicker
                      className="valorDataCaixa__fields--field muiDatePicker"
                      label="Data de Emissão*"
                      inputFormat="DD-MM-YYYY"
                      renderInput={(params) => <TextField {...params} />}
                      onChange={(value) => setDataCredencial(value)}
                      value={dataCredencial}
                      clearable
                    />
                  </LocalizationProvider>

                  <InputText
                    id="nrCredencialInput"
                    className="adicionar-entrada__modal__container--span2"
                    label="Nº do Credencial*"
                    initialValue={nrCredencial}
                    handleChange={nrCredencialChangeHandler}
                  />

                  <FormControl fullWidth size="small">
                    <InputLabel id="label-categoria">
                      Categoria Beneficiário (opcional)
                    </InputLabel>
                    <Select
                      labelId="label-categoria"
                      id="select_categoria"
                      value={categoriaBeneficiario}
                      label="Categoria"
                      onChange={(e) => {
                        setCategoriaBeneficiario(e.target.value);
                      }}
                    >
                      <MenuItem value="">Selecione uma categoria</MenuItem>
                      <MenuItem value="TCP">Trabalhado Conta Própria</MenuItem>
                      <MenuItem value="TCO">Trabalhado Conta Outrem</MenuItem>
                      <MenuItem value="PA">Função Pública</MenuItem>
                      <MenuItem value="MBCSS">
                        Migrantes - Beneficiários Convenções Segurança Social
                      </MenuItem>
                    </Select>
                  </FormControl>

                  {auth.perm.includes("c-maj") && (
                    <>
                      <h2>Majoração se aplicável</h2>

                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        <input
                          type="checkbox"
                          id="majoracaoAutomatica"
                          checked={majoracaoAutomatica}
                          onChange={handleMajoracaoAutomaticaChange}
                          disabled={
                            tipoCobertura === "PARTICULAR" ||
                            modalidadePagamento === "REEMBOLSO_CLIENTE"
                          }
                        />
                        <label
                          htmlFor="majoracaoAutomatica"
                          className="majoracaoCheckboxLabel"
                        >
                          Calcular automaticamente (15%)
                        </label>
                      </div>

                      <TextField
                        label="Majoração"
                        type="number"
                        value={majoracao}
                        onChange={majoracaoChangeHandler}
                        disabled={majoracaoAutomatica}
                        InputProps={{
                          inputProps: {
                            min: 0,
                            step: "any",
                          },
                        }}
                        fullWidth
                        variant="outlined"
                        className="adicionar-entrada__modal__container--span2"
                      />
                    </>
                  )}
                </div>
              )}
          </div>
          {mensagemErro && (
            <div className="fluxo-atendimento__modal__erros">
              {mensagemErro}
            </div>
          )}
          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalAprovarOrcamento}
              style={{ display: "block" }}
            >
              Fechar
            </span>
            <span
              className="blue-button"
              disabled={isSubmitting}
              onClick={preSubmit}
              style={{ display: "block" }}
            >
              {isSubmitting ? "Aprovando..." : "Aprovar"}
            </span>
          </div>
        </Box>
      </Modal>

      {/* ADICIONAR: Dialog de confirmação de conversão de agendamentos */}
      <Dialog
        open={confirmDialog.open}
        onClose={handleCancelarConversao}
        maxWidth="md"
        fullWidth
      >
        <DialogTitle
          sx={{ bgcolor: "#f5f5f5", borderBottom: "2px solid #2196f3" }}
        >
          {confirmDialog.aprovacaoParcial &&
          confirmDialog.agendamentosParaRemover?.agendamentosParaRemover > 0
            ? "Confirmação de Aprovação Parcial com Agendamentos"
            : "Confirmação de Conversão de Agendamentos"}
        </DialogTitle>

        <DialogContent sx={{ mt: 2 }}>
          <DialogContentText sx={{ mb: 2, fontWeight: 500 }}>
            {confirmDialog.mensagem}
          </DialogContentText>

          {/* Se for aprovação parcial com agendamentos para remover */}
          {confirmDialog.aprovacaoParcial &&
            confirmDialog.agendamentosParaRemover && (
              <Box sx={{ mb: 3 }}>
                {confirmDialog.agendamentosParaRemover.agendamentosParaManter >
                  0 && (
                  <Alert severity="success" sx={{ mb: 2 }}>
                    <strong>
                      {
                        confirmDialog.agendamentosParaRemover
                          .agendamentosParaManter
                      }{" "}
                      agendamento(s)
                    </strong>{" "}
                    serão MANTIDOS e convertidos para o plano de tratamento.
                  </Alert>
                )}

                {confirmDialog.agendamentosParaRemover.agendamentosParaRemover >
                  0 && (
                  <Alert severity="error" sx={{ mb: 2 }}>
                    <strong>
                      {
                        confirmDialog.agendamentosParaRemover
                          .agendamentosParaRemover
                      }{" "}
                      agendamento(s)
                    </strong>{" "}
                    serão ELIMINADOS pois seus procedimentos foram removidos da
                    aprovação.
                  </Alert>
                )}
              </Box>
            )}

          {/* Lista todos os agendamentos */}
          {confirmDialog.agendamentos &&
            confirmDialog.agendamentos.length > 0 && (
              <Box sx={{ mt: 2 }}>
                <Typography
                  variant="subtitle1"
                  gutterBottom
                  sx={{ fontWeight: "bold", mb: 2 }}
                >
                  Detalhes dos agendamentos:
                </Typography>

                <List
                  dense
                  sx={{
                    bgcolor: "background.paper",
                    border: "2px solid #2196f3",
                    borderRadius: 1,
                    p: 1,
                    maxHeight: "300px",
                    overflow: "auto",
                  }}
                >
                  {confirmDialog.agendamentos.map((ag, index) => {
                    const dataInicio = moment(ag.data_inicio);
                    const dataFim = ag.data_fim ? moment(ag.data_fim) : null;

                    // Verificar se este agendamento será removido (se temos a informação)
                    const seraRemovido =
                      confirmDialog.agendamentosParaRemover?.agendamentosParaRemoverDetalhes?.some(
                        (agRemover) => agRemover.id === ag.id,
                      );

                    return (
                      <ListItem
                        key={ag.id || index}
                        sx={{
                          borderBottom:
                            index < confirmDialog.agendamentos.length - 1
                              ? "1px solid #e0e0e0"
                              : "none",
                          py: 1.5,
                          bgcolor: seraRemovido ? "#ffebee" : "inherit",
                        }}
                      >
                        <ListItemText
                          primary={
                            <Box>
                              <Typography
                                variant="body1"
                                component="span"
                                fontWeight="bold"
                                color={seraRemovido ? "error" : "inherit"}
                              >
                                {seraRemovido && "❌ "}
                                {ag.tratamento || "Tratamento não especificado"}
                                {seraRemovido && " (SERÁ ELIMINADO)"}
                              </Typography>
                              <Typography
                                variant="body2"
                                component="div"
                                sx={{ mt: 0.5 }}
                              >
                                📅 {dataInicio.format("DD/MM/YYYY")} - ⏰{" "}
                                {dataInicio.format("HH:mm")}
                                {dataFim && ` até ${dataFim.format("HH:mm")}`}
                              </Typography>
                            </Box>
                          }
                          secondary={
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mt: 0.5 }}
                            >
                              👨‍⚕️ Dr(a). {ag.medico || "Médico não definido"}
                              {ag.cliente && ` • 👤 ${ag.cliente}`}
                            </Typography>
                          }
                        />
                      </ListItem>
                    );
                  })}
                </List>
              </Box>
            )}
        </DialogContent>

        <DialogActions sx={{ p: 2, bgcolor: "#f5f5f5" }}>
          <Button
            onClick={handleCancelarConversao}
            variant="outlined"
            color="secondary"
            size="large"
          >
            Cancelar
          </Button>
          <Button
            onClick={handleConfirmarConversao}
            variant="contained"
            color={
              confirmDialog.agendamentosParaRemover?.agendamentosParaRemover > 0
                ? "error"
                : "primary"
            }
            size="large"
            sx={{ ml: 2 }}
          >
            {confirmDialog.agendamentosParaRemover?.agendamentosParaRemover > 0
              ? `Confirmar e Eliminar ${confirmDialog.agendamentosParaRemover.agendamentosParaRemover} Agendamento(s)`
              : "Confirmar e Aprovar Orçamento"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}

export default ModalAprovarOrcamento;
